export default "__VITE_ASSET__mlqQ6e9m__"